import SuperTokens from 'supertokens-auth-react';
import Multitenancy from 'supertokens-auth-react/recipe/multitenancy';
import Passwordless from 'supertokens-auth-react/recipe/passwordless';
import Session from 'supertokens-auth-react/recipe/session';
import { env } from './env';

export function initSuperTokens() {
  SuperTokens.init({
    appInfo: {
      appName: 'Sara',
      apiDomain: env.VITE_API_DOMAIN,
      websiteDomain: env.VITE_CONSOLE_DOMAIN,
      apiBasePath: '/auth',
      websiteBasePath: '/auth',
    },
    recipeList: [
      Multitenancy.init({
        override: {
          functions: (oI) => ({
            ...oI,
            getTenantId: () => env.VITE_SUPERTOKENS_TENANT_ID,
          }),
        },
      }),
      Passwordless.init({ contactMethod: 'EMAIL' }),
      Session.init(),
    ],
  });
}
